export default __webpack_public_path__ + "static/media/FOTO_vrienden_handen.d20c2b0d.jpg";